import React from "react";
import "../detail-wrapper/styles.css";
import Text from "../typography/text";
import StatusIndicatorHeader from "../status-indicator/status-indicator";
import { useNavigate } from "react-router-dom";

const DetailWrapper = ({
  poNumber,
  orderStatus,
  orderStatusType,
  orderDate,
  orderType,
  placedBy,
  shippedTo,
  shippingAddress,
  billedTo,
  billingAddress,
  shippingContact,
  apContact,
  linkToOrder,
}) => {
  const navigate = useNavigate();

  return (
    <div className="details-wrapper-container">
      <div className="details-wrapper-title-container">
        <div className="details-wrapper-title-container-left">
          <Text>Order</Text>
          <StatusIndicatorHeader
            statusType={orderStatusType}
            status={orderStatus}
          />
        </div>
        <div
          onClick={() => navigate(linkToOrder)}
          style={{ cursor: "pointer" }}
        >
          <Text variant="tinyText" color={"primaryColor"}>
            View Full Order
          </Text>
        </div>
      </div>
      <div className="details-wrapper-item-container">
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            PO Number
          </Text>
          <Text variant="tinyText">{poNumber}</Text>
        </div>
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Order Date & Time
          </Text>
          <Text variant="tinyText">{orderDate}</Text>
        </div>
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Order Type
          </Text>
          <Text variant="tinyText">{orderType}</Text>
        </div>
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Placed By
          </Text>
          {placedBy && <Text variant="tinyText">{placedBy}</Text>}
        </div>
      </div>
      <div className="details-wrapper-item-container">
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Shipped To
          </Text>
          {shippedTo && <Text variant="tinyText">{shippedTo}</Text>}
          <Text variant="tinyText" color={"lightText"}>
            {shippingContact}
          </Text>
        </div>
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Shipping Address
          </Text>
          {shippingAddress && <Text variant="tinyText">{shippingAddress}</Text>}
        </div>
      </div>
      <div className="details-wrapper-item-container">
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Billed To
          </Text>
          <Text variant="tinyText">{billedTo}</Text>
          <Text variant="tinyText" color={"lightText"}>
            {apContact}
          </Text>
        </div>
        <div className="details-wrapper-item-section">
          <Text variant="tinyText" color={"lightText"}>
            Billed Address
          </Text>
          <Text variant="tinyText">{billingAddress}</Text>
        </div>
      </div>
    </div>
  );
};

export default DetailWrapper;
